<div class="flex h-screen flex-col">
  <!-- Header -->
  <app-header
    class="layout-header"
    [menuToggleEnabled]="true"
    [title]="title"
    (menuToggle)="menuOpened = !menuOpened">
  </app-header>

  <div class="flex flex-1 overflow-hidden">
    <!-- Sidebar -->
    <aside class="transition-all duration-300 overflow-hidden bg-white border-r border-neutral-200 flex-shrink-0"
           [class.w-60]="menuOpened"
           [class.w-[60px]]="!menuOpened && !isXSmall"
           [class.hidden]="!menuOpened && isXSmall">
      <app-side-navigation-menu
        [compactMode]="!menuOpened"
        (selectedItemChanged)="navigationChanged($event)"
        (openMenu)="navigationClick()">
      </app-side-navigation-menu>
    </aside>

    <!-- Mobile overlay backdrop -->
    @if (menuOpened && isXSmall) {
      <div class="fixed inset-0 bg-black/30 z-40" (click)="menuOpened = false"></div>
    }

    <!-- Main content -->
    <main #mainContent class="flex-1 overflow-y-auto bg-neutral-50">
      <div class="content" id="app-content">
        <ng-content></ng-content>
      </div>
    </main>
  </div>
</div>
